import React, { Component } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

class PrefectureInput extends Component {
  handleButtonClick() {
    const { province, prefecture, category } = this.props;

    window.history.replaceState({
      province: province,
      prefecture: prefecture
    }, "", window.location.href);
    window.location.href = "/data_exploration/prefecture/" + prefecture.id + "/category/" + category;
  }

  render() {
    const { name, year, value } = this.props;

    if(value) {
      return (
        <div className="sl-stat-row">
          <div className="sl-stat-label-wrap">
            <span className="sl-stat-label">{name}</span>
            <span className="sl-stat-year-badge">{year}</span>
          </div>
          <div className="sl-stat-right">
            <span className="sl-stat-val">{value}</span>
            <button className="sl-stat-drill-btn" onClick={this.handleButtonClick.bind(this)}>
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

export default PrefectureInput;
